<template>
	<div :class="height_limit ? 'parent' : 'parent-long'">
		<comments
		:joborderid="comment_joborderid"
		:show="show_comments"
		v-on:cancel="cancel_comment"
		v-on:save="save_comment"
		></comments>

		<div style="display:inline-block">
	        <div v-if="searchbar==true" class="search-field" style="float:left">
	            <button v-on:click="clear()" style="height:30px; width:40px;"><font-awesome-icon icon="times" /></button>
	    		<input v-model="search_term" @keydown.enter="setRouter(true)" @input="setRouter(false)"></input>
	            <button v-on:click="setRouter(true)" style="height:30px; width:40px;"><font-awesome-icon icon="search" /></button>

				<b>Limit</b>
				<input v-model="limit" @keydown.enter="setRouter(true)" style="width:60px"></input>

				<b v-if="usePages==true">Page</b>
				<button v-if="usePages==true" v-on:click="addPage(-1)"><</button>
				<input v-if="usePages==true" v-model="page" @keydown.enter="setRouter(true)" style="width:60px"></input>
				<button v-if="usePages==true" v-on:click="addPage(1)">></button>

				<b v-if="use_size==true">Size</b>
				<input v-if="use_size==true" v-model="heightScale" style="width:60px"></input>
	        </div>

			<filtr
				v-if="filter_options!=null && filter_options.length>0"
				style="float:left"
				:id=id
				:filter_options=filter_options
				v-on:input="setData"
			></filtr>
		</div>

		<div class="scroll" v-bind:style="navbar?'margin-bottom:50px':'margin-bottom:10px'">
			<table :key=update_key>
				<thead v-if="column_names.length>0">
					<tr v-if="collapseable==true">
						<th style="width:30px">
							<button v-if="collapsed==false" v-on:click="collapse()">-</button>
							<button v-else v-on:click="collapse()">+</button>
						</th>

						<th v-if="button_name!=null && perms.includes(button_perm)"
						v-bind:colspan="column_names.length"
						class="table-header">
							{{table_name}} Table <button class="copy-table" v-on:click="copyTable()">Copy Table</button>
						</th>
						<th v-else
						v-bind:colspan="column_names.length-1"
						class="table-header">
							{{table_name}} Table <button class="copy-table" v-on:click="copyTable()">Copy Table</button>
						</th>

					</tr>
					<tr v-else>
						<th v-if="button_name!=null && perms.includes(button_perm)"
						v-bind:colspan="column_names.length+1"
						class="table-header">
							{{table_name}} Table <button class="copy-table" v-on:click="copyTable()">Copy Table</button>
						</th>
						<th v-else
						v-bind:colspan="column_names.length"
						class="table-header">
							{{table_name}} Table <button class="copy-table" v-on:click="copyTable()">Copy Table</button>
						</th>
					</tr>

					<tr>
						<th v-if="button_name!=null && perms.includes(button_perm) && collapsed==false" style="width:30px">{{button_name}}</th>

						<th v-for="(name, index) in column_names" v-if="column_names[index]!='Color' && collapsed==false">
							<div style="display:inline-block; white-space:nowrap;">
								{{name}}
								<button v-if="sort_value[index]==0" v-on:click="sort(index)"><font-awesome-icon icon="sort" /></button>
								<button v-else-if="sort_value[index]==1" v-on:click="sort(index)"><font-awesome-icon icon="sort-up" /></button>
								<button v-else-if="sort_value[index]==2" v-on:click="sort(index)"><font-awesome-icon icon="sort-down" /></button>
							</div>
						</th>
					</tr>
				</thead>
				<thead v-else-if="loading==true"><tr><th class="table-header">{{table_name}} Table Loading...</th></tr></thead>
                <thead v-else><tr><th class="table-header">{{table_name}} Table Empty</th></tr></thead>
				<tbody v-if="column_names.length>0 && collapsed==false">
					<tr v-for="(column, col) in column_data">
						<td v-if="button_name!=null && perms.includes(button_perm)" style="width:30px">
							<button v-on:click="select(col)">{{button_name}}</button>
						</td>

						<td v-for="(data, index) in column" v-if="column_names[index]!='Color'" v-bind:id="'tableRow-'+col">
							<div v-if="column_names[index] == 'Document' && data!='null'">
								<document :id="index" :dir="'doc_'+data+'.jpg'" :doc_id="data" style="width:200px"></document>
							</div>
							<div v-else-if="column_names[index] == 'Side' && data!='null'" v-bind:id="'side-'+col">
								{{data}}
							</div>
							<div v-else-if="column_names[index] == 'CheckIn'">
								<button v-on:click="check(true, column_data[col][0])">Check In</button>
							</div>
							<div v-else-if="column_names[index] == 'CheckOut'">
								<button v-on:click="check(false, column_data[col][0])">Check Out</button>
							</div>
							<div v-else-if="column_names[index] == 'Add_Comment'">
								<button v-on:click="add_comment(col)">Add Comment</button>
							</div>
							<div v-else-if="column_names[index] == 'Comments'" style="font-size:14px; overflow-y:scroll; max-height:60px; word-break:break-word;">
								{{data}}
							</div>
							<div v-else-if="column_names[index] == 'Date'" v-bind:id="'date-'+col">
								<datetime
								v-model="date_values[col]"
								:index=col
								:use_X="false"
								v-on:inputIndex="setDateTime"
								style="width:600px;"
								/>
							</div>
							<div v-else-if="column_names[index] == 'Description'">
								<textarea
								:id="'desc-'+col"
						        @input="setDescriptionData"
								style="width:100%; min-height:50px;"
								:value="data"
								/>
							</div>
							<div v-else-if="column_names[index] == 'Type'">
								<autocomplete
								:id="'type-'+col"
								:index=col
								:type=51
								:value="data"
								v-on:finish="setTypeData"
								style="width:100%;"/>
							</div>
							<div v-else-if="column_names[index] == 'Images' && data!='null'">
								<inventorypics :id="index" :inventorypic_id="column[0]" :height="(75*heightScale/100)+'px'" :count="data" :imageCount=5 style="width:100%"></inventorypics>
							</div>
							<div v-else>
								{{data}}
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>

		<div v-if="navbar==true" class="nav-bar">
			<div>
				<button v-for="(item, index) in nav_items" v-if="perms.includes(nav_item_perms[index])" v-on:click="button(item)">{{item}}</button>
			</div>
		</div>
	</div>
</template>

<script>
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		button_perm:String,
		searchbar:Boolean,
		filter_options:Array,
		navbar:Boolean,
		nav_items:Array,
		nav_item_perms:Array,
		button_name: '',
		term: '',
		termchange:false,
        id: Number,
		reroute: {
            type: String,
            required: false,
            default: ''
        },
		height_limit:{
			type:Boolean,
			required:false,
			default:true
		},
		collapseable:{
			type:Boolean,
			required:false,
			default:false
		},
		table_name:{
			type:String,
			required:false,
			default:""
		},
		use_size:{
			type:Boolean,
			required:false,
			default:false
		},
		usePages:{
			type:Boolean,
			required:false,
			default:false
		},
    },
	data() {
		return {
			collapsed:false,
			perms:[],
			search_term:'',
			limit:50,
			page:0,
			heightScale:100,
			column_names: [],
			column_data:[],
			sort_value:[],
			loading:true,
			filtr:[],
			date_values:[],

			altered_values:[],
			update_key:0,

			show_comments:false,
			comment_joborderid:0,
			comment_index:0,
		}
	},
	async created () {
		this.perms = api.getPerms();
		this.search_term = this.term;

		var getLimit = parseInt(api.getCookie("limit_"+this.id))
		if(getLimit!=null && getLimit!=undefined && !isNaN(getLimit)) { this.limit = getLimit }

		var getPage = parseInt(api.getCookie("page_"+this.id))
		if(getPage!=null && getPage!=undefined && !isNaN(getPage)) { this.page = getPage }

		var getHeight = parseInt(api.getCookie("height_"+this.id))
		if(getHeight!=null && getHeight!=undefined && !isNaN(getHeight)) { this.heightScale = getHeight }

		this.search(true)
	},
	methods: {
		collapse(){
			this.collapsed = !this.collapsed
		},
		async sort(index){
			this.sort_value.splice(index, 1, this.sort_value[index]+1);
			if(this.sort_value[index]>2)
				this.sort_value.splice(index, 1, 0);
			this.search(true)
		},
        async clear (){
            this.search_term = "";
            this.setRouter(true);
        },
		async setRouter(full){
			if(this.reroute!=''){
				if(this.search_term==''||this.search_term==undefined) {
					router.replace(this.reroute);
				}else {
					if(full){
						router.push(this.reroute+'?q='+this.search_term);
					}else{
						router.replace(this.reroute+'?q='+this.search_term);
					}
				}
			}

			this.search(full);
		},
		async search (full){
			var currentTerm = this.search_term;
			var timeout = /*full?0:*/500;

			this.limit = parseInt(this.limit)
			this.page = parseInt(this.page)

			document.cookie="limit_"+this.id+"="+this.limit+";";
			document.cookie="page_"+this.id+"="+this.page+";";

			setTimeout(() => {
				if(currentTerm!=this.search_term && this.search_term!=undefined){
					return;
				}else{
					this.loading=true;
					api.postData(
		                {
		                    type:"search",
		                    data:{
								pageid:this.id,
								fullsearch:full,
								limit:this.limit,
								data:[
			                        this.search_term
			                    ],
								sort:this.sort_value,
								filter:this.filter_options,
								page:this.page,
							}
		                }
		            ).then((res) => {
						this.update_key++;
						this.clearColors()

			            this.column_names = res.data.data.column_names;
						this.column_data = res.data.data.column_data;
						if(this.sort_value.length==0){
							for(let i = 0;i<res.data.data.column_names.length;i++) {
								this.sort_value[i] = 0;
							}
						}

						this.date_values = [];
						for(let i = 0;i<this.column_data.length;i++){
							for(let j = 0;j<this.column_data[i].length;j++){
								if(this.column_names[j]=="Date"){
									this.date_values.push(this.column_data[i][j])
									//alert(this.column_data[i][j])
								}
							}
						}

						if(full){
							api.setWOColors()
						}
						this.setColors()
			        }).finally((res)=>{
						this.loading=false;
					});
				}
			}, timeout);
		},
		async clearColors(){
			if(this.column_names.includes('Side')){
				let position = this.column_names.indexOf('Side')
				for(let i = 0; i<this.column_data.length;i++){

					var element = document.getElementById('side-'+i).parentElement
					element.removeAttribute('style');
				}
			}

			if(this.column_names.includes('Color')){
				let position = this.column_names.indexOf('Color')
				for(let i = 0; i<this.column_data.length;i++){

					var row = document.getElementById('tableRow-'+i)
					row.removeAttribute('style');
				}
			}
		},
		async setColors(){
			let stateCheck = setInterval(() => {
				if (document.getElementById("tableRow-0")!=null) {
					clearInterval(stateCheck);

					if(this.column_names.includes('Side')){
						let position = this.column_names.indexOf('Side')
						for(let i = 0; i<this.column_data.length;i++){
							if(this.column_data[i][position]=="Port"){

								var element = document.getElementById('side-'+i).parentElement
								var style = 'background-color:#ffb5b5;';
								element.setAttribute('style', style);
							}
							else if(this.column_data[i][position]=="Starboard"){

								var element = document.getElementById('side-'+i).parentElement
								var style = 'background-color:#a5ffa5;';
								element.setAttribute('style', style);
							}
						}
					}

					if(this.column_names.includes('Color')){
						let position = this.column_names.indexOf('Color')
						for(let i = 0; i<this.column_data.length;i++){
							if(this.column_data[i][position]!=null){

								var color = this.column_data[i][position]
								var row = document.getElementById('tableRow-'+i)
								var style = 'background-color: #'+color+';';
								row.setAttribute('style', style);
							}
						}
					}
				}
			}, 100);
		},
        async select (index){
            api.postData(
                {
                    type:"select",
					data:{
						pageid:this.id,
						term:this.search_term,
						firstcolumn:this.column_names[0]
					}
                }
            ).then((res) => {
				if(res.data.data.to!=null && this.reroute!=''){
					router.push('/'+res.data.data.to+'?q='+this.column_data[index][res.data.data.select]);
				}
            })

			this.$emit('select', this.column_data[index][0]);
        },
		async button (name){
			if(name=="Cancel"){
				this.$emit('select', '');
			}else if(name=="Save"){
				this.sendDateTimes();
			}

			api.postData(
				{
					type:"button",
					data:{
						pageid:this.id,
						buttonname:name,
					}
				}
			).then((res) => {
				if(res.data.data.to!=null) {
					if(res.data.data.useterm) {
						router.push('/'+res.data.data.to+'?q='+this.search_term);
					} else {
						router.push('/'+res.data.data.to);
					}
				}
			});
		},
		async copyTable(){
			var copyText = ''


			for(let i = 0;i < this.column_names.length;i++){
				copyText += this.column_names[i] + '\t'
			}
			copyText+='\n'

			for(let i = 0;i < this.column_data.length;i++){
				for(let j = 0; j< this.column_data[i].length;j++){
					copyText += this.column_data[i][j] + '\t'
				}
				copyText+='\n'
			}

			var el = document.createElement('textarea');
		    el.value = copyText;
		    document.body.appendChild(el);
		    el.select();
			el.setSelectionRange(0, 99999);
		    document.execCommand('copy');
		    document.body.removeChild(el);
			alert("copied to clipboard")
		},
		setDateTime(index, value, changedManually){
			if(changedManually == true){
				var column_date = 0;
				for(let i = 0;i<this.column_names.length;i++){
					if(this.column_names[i]=="Date"){
						column_date = i;
					}
				}

				if(this.date_values[index].substr(0,16)!=this.column_data[index][column_date].substr(0,16)){
					var isInArray = -1;
					for(var i = 0;i<this.altered_values.length;i++){
						if(this.altered_values[i][0]==this.column_data[index][0]){
							isInArray = i;
							break;
						}
					}

					if(isInArray==-1){
						this.altered_values.push([this.column_data[index][0], this.date_values[index]])
					}else{
						this.altered_values[isInArray][1] = this.date_values[index]
					}
				}
			}
		},
		setTypeData(index, value){
			var column_date = 0;
			for(let i = 0;i<this.column_names.length;i++){
				if(this.column_names[i]=="Type"){
					column_date = i;
				}
			}

			var isInArray = -1;
			for(var i = 0;i<this.altered_values.length;i++){
				if(this.altered_values[i][0]==this.column_data[index][0]){
					isInArray = i;
					break;
				}
			}

			if(value==''){
				value = undefined
			}

			if(isInArray==-1){
				this.altered_values.push([this.column_data[index][0], value, this.column_data[index][1]])
			}else{
				this.altered_values[isInArray][1] = value
			}
		},
		setDescriptionData(obj){
			var id = obj.target.id
			var index = id.substr(5)
			var value = document.getElementById(id).value

			var column_date = 0;
			for(let i = 0;i<this.column_names.length;i++){
				if(this.column_names[i]=="Description"){
					column_date = i;
				}
			}

			var isInArray = -1;
			for(var i = 0;i<this.altered_values.length;i++){
				if(this.altered_values[i][0]==this.column_data[index][0]){
					isInArray = i;
					break;
				}
			}

			if(isInArray==-1){
				this.altered_values.push([this.column_data[index][0], this.column_data[index][3], value])
			}else{
				this.altered_values[isInArray][2] = value
			}
		},
		sendDateTimes(){

			api.postData(
				{
					type:"insert",
					data:{
						pageid:this.id,
						data:this.altered_values,
					}
				}
			).then((res) => {
				this.altered_values = [];

				alert("Saved");
				this.search(true);
			});
		},
		setData(filtr, update){
			this.filtr = filtr
			if(update){
				this.search(true)
			}
		},
		addPage(amt){
			this.page+=amt*this.limit;
			if(this.page<0){
				this.page=0;
			}

			this.setRouter(true)
		},
		check(isIn, itemId){
			this.$emit('check', isIn, itemId);
		},
		async add_comment(index) {
			let jobordercol = 0;
			for(var i = 0;i<this.column_names.length;i++){
				if(this.column_names[i]=='WONumber'){
					jobordercol = i;
				}
			}

			this.comment_index = index;
			this.comment_joborderid = parseInt(this.column_data[index][jobordercol].substr(3,5));
			this.show_comments = true;
		},
		async cancel_comment() {
			this.comment_index = 0;
			this.comment_joborderid = 0;
			this.show_comments = false;
		},
		async save_comment(comment) {
			for(var i = 0;i<this.column_names.length;i++){
				if(this.column_names[i]=='Comments'){
					this.column_data[this.comment_index][i] += ", "+comment;
				}
			}
		},
	},
	watch:{
		term(){
			this.search_term = this.term;
			if(this.termchange==true){
				this.search(true);
			}
		},
		heightScale(){
			document.cookie="height_"+this.id+"="+this.heightScale+";";
		},
	}
}
</script>



// WEBPACK FOOTER //
// src/layouts/layout_8.vue